/* RESPONSIBLE TEAM: team-inbox-management */
import Model, { attr } from '@ember-data/model';

export default class CancellationQuestionResponse extends Model {
  @attr() appId;
  @attr() adminId;
  @attr('array') reasonIds;
  @attr() comment;
}
